import { DevHubGrid, devhubMakeStyles } from '@devxdiscover/devhub-ui';
import {
  CorporateEntity,
  CorporateEntityProps,
} from '../onboarding/types/onboardingTypes';

const useStyles = (height: number) =>
  devhubMakeStyles({
    Cable: {
      border: 0,
      height: `${height * 1.5}rem`,
    },
    Nbcu: {
      border: 0,
      height: `${height * 0.5}rem`,
    },
    Sky: {
      border: 0,
      height: `${height * 1.5}rem`,
    },
  });

interface Props {
  name?: string;
  entity: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
}

const sizeToHeightMap = {
  tiny: 0.75,
  small: 1,
  medium: 1.5,
  large: 2,
};

/**
 * A functional component that renders an icon for the app entity.
 * @param props Props of the component
 * @param props.name Optional name value passed to the component
 * @param props.entity entity value passed to the component
 */
const AppEntityIcon = (props: Props) => {
  const classes = useStyles(sizeToHeightMap[props.size ?? 'small'])();

  const corporateEntity = CorporateEntityProps.find(
    entity => entity.name === (props?.entity ?? CorporateEntity.CABLE),
  );
  return (
    <DevHubGrid container>
      {props?.name && <DevHubGrid item>{props?.name}</DevHubGrid>}
      <DevHubGrid item>
        {corporateEntity && (
          <img
            className={classes[corporateEntity.name]}
            src={corporateEntity.svg}
            alt="entity icon"
          />
        )}
      </DevHubGrid>
    </DevHubGrid>
  );
};

export default AppEntityIcon;
